"use client";

import { Route } from "@faire/web-api/Route";
import { props as faireDirectRouteProps } from "@faire/web-api/routes/direct/brandAlias";
import React from "react";

import { LazyFaireDirectLandingPageRoot } from "@faire/retailer/views/faire-direct/LazyFaireDirectLandingPageRoot";

export const RenderFaireDirectLandingPage = () => {
  return (
    <Route
      {...faireDirectRouteProps}
      component={LazyFaireDirectLandingPageRoot}
    />
  );
};
